import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {PricingRoutingModule} from './pricing-routing.module';
import {PricingComponent} from './components/pricing.component';

@NgModule({
  declarations: [PricingComponent],
  imports: [
    CommonModule,
    SharedModule,
    PricingRoutingModule,
    //  EffectsModule.forFeature([PricingEffects]),
  ],
  providers: [
    //  SportBetListService
  ],
})
export class PricingModule {}
